import { createSelector } from "reselect";

const getAACTData = (state) => {
  return __IS_COMPONENTS_PORTAL__
    ? state?.variantResult?.genes?.[state.selectedGeneIndexClinical]?.aact
    : state && state.variantResult && state.variantResult.aact;
};
const getAACTStatuses = createSelector(getAACTData, (data) => {
  if (!Object.keys(data || {}).length) {
    return null;
  }
  const { items } = data;
  const statuses = {};

  items.forEach((x) => {
    if (statuses[x.status]) {
      statuses[x.status] += 1;
    } else {
      statuses[x.status] = 1;
    }
  });
  return statuses;
});

export { getAACTData, getAACTStatuses };
